import { useSelector } from 'react-redux';

import { selectCategoryId } from '../selectors/categoryId';

export const useCategoryId = (): string | undefined =>
  useSelector(selectCategoryId)?.toString() || undefined;
